/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_accionProyecto as accionProyecto,
  rec_Bo as Bo,
  rec_DetalleHilo as DetalleHilo,
  rec_DetalleTarea as DetalleTarea,
  rec_EstadoError as EstadoError,
  rec_JSXRuntime as JSXRuntime,
  rec_NuevoHilo as NuevoHilo,
  rec_Paginacion as Paginacion,
  rec_React as React,
  rec_Ro as Ro,
  rec_Ti as Ti,
  rec_api as api,
  rec_ii as ii,
  rec_mi as mi,
  rec_pS as pS,
} from "../../runtime/index.jsx";
export function DiscusionesProyecto({ proyecto: e }) {
  let [t, n] = (0, React.useState)([]),
    [r, i] = (0, React.useState)(0),
    [a, o] = (0, React.useState)(0),
    [s, c] = (0, React.useState)([]),
    [l, u] = (0, React.useState)(!0),
    [f, p] = (0, React.useState)(``),
    [m, h] = (0, React.useState)(!1),
    [g, _] = (0, React.useState)(null),
    [v, y] = (0, React.useState)(null),
    b = !accionProyecto(e, `planner.discusiones.crear`),
    x = (0, React.useCallback)(async () => {
      u(!0);
      try {
        let [t, a] = await Promise.all([
          api(`/discusiones?proyecto=${e.id}&pagina=${r}&tamano=25`),
          api(`/metas?proyecto=${e.id}`),
        ]);
        (n(t.items),
          o(t.total),
          r > 0 && t.items.length === 0 && i(r - 1),
          c(a),
          p(``));
      } catch (e) {
        p(e.message);
      } finally {
        u(!1);
      }
    }, [e.id, r]);
  return (
    (0, React.useEffect)(() => {
      x();
    }, [x]),
    l ? (
      <div
        className={`flex items-center gap-2 text-sm text-(--text)`}
        children={[
          (0, JSXRuntime.jsx)(ii, {
            className: `h-4 w-4 animate-spin`,
          }),
          ` Cargando…`,
        ]}
      />
    ) : (
      <div
        className={`flex flex-col gap-4`}
        children={[
          <div
            className={`flex items-center justify-between`}
            children={[
              <span
                className={`text-sm text-(--text)`}
                children={[a, ` hilos`]}
              />,
              !b && (
                <button
                  type={`button`}
                  onClick={() => h(!0)}
                  className={Ro}
                  children={[
                    <Ti className={`mr-1 inline h-4 w-4`} />,
                    ` Nuevo hilo`,
                  ]}
                />
              ),
            ]}
          />,
          <EstadoError mensaje={f} onReintentar={x} />,
          t.length === 0 ? (
            <div
              className={`rounded-2xl border border-dashed border-(--border) p-10 text-center`}
              children={[
                (0, JSXRuntime.jsx)(mi, {
                  className: `mx-auto h-8 w-8 text-(--text)`,
                }),
                <p
                  className={`mt-2 text-sm text-(--text)`}
                  children={`Sin discusiones. Abre un hilo para dejar registro de una decision.`}
                />,
              ]}
            />
          ) : (
            <ul
              className={`flex flex-col gap-2`}
              children={t.map((e) => (
                <li
                  key={e.id}
                  children={
                    <button
                      type={`button`}
                      onClick={() => _(e.id)}
                      className={`${Bo} w-full text-left transition hover:shadow-(--shadow)`}
                      children={[
                        <div
                          className={`flex items-center gap-2`}
                          children={[
                            <span
                              className={`min-w-0 flex-1 truncate font-medium text-(--text-h)`}
                              children={e.titulo}
                            />,
                            e.cerrada && (
                              <span
                                className={`rounded-full bg-(--panel) px-2 py-0.5 text-xs text-(--text)`}
                                children={`Cerrado`}
                              />
                            ),
                          ]}
                        />,
                        <p
                          className={`mt-1 text-xs text-(--text)`}
                          children={[
                            e.creadoPorNombre || `Alguien`,
                            ` · `,
                            pS(e.creadoEn),
                            ` · `,
                            e.totalComentarios ?? 0,
                            ` respuestas`,
                          ]}
                        />,
                      ]}
                    />
                  }
                />
              ))}
            />
          ),
          <Paginacion pagina={r} tamano={25} total={a} onChange={i} />,
          m && <NuevoHilo proyecto={e} onClose={() => h(!1)} onGuardado={x} />,
          g && (
            <DetalleHilo
              id={g}
              proyecto={e}
              soloLectura={b}
              onClose={() => _(null)}
              onCambio={x}
              onCrearTarea={(e) => {
                (_(null), y(e));
              }}
            />
          ),
          v && (
            <DetalleTarea
              proyecto={e}
              tarea={null}
              preset={v}
              metas={s}
              onClose={() => y(null)}
              onGuardado={() => {
                (y(null), x());
              }}
            />
          ),
        ]}
      />
    )
  );
}
